import { selectJobInfo, selectJobInfoLoading } from '../../store/general/selectors';
import { getUserInfoThunk, signInThunk } from '../../store/auth/thunks';
import { selectFetchStatus } from '../../store/auth/selectors';
import { TypographyLogo } from '../../assets/icons/common';
import Button from '../../components/Button';
import Input from '../../components/Input';
import CheckBox from '../../components/CheckBox';
import { validateEmail } from '../../utils/generalHelpers';
import { getJobInfoThunk } from '../../store/general/thunks';
import { useDispatch, useSelector } from '../../store/store';
import Loading from '../../components/Loading';
import styles from './style.module.scss';
import { useEffect, useState } from 'react';
import {
    useNavigate,
    useSearchParams,
} from 'react-router-dom';

function JobDescription() {
    const loading = useSelector(selectJobInfoLoading);
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const jobInfo = useSelector(selectJobInfo);
    const jobId = searchParams.get('jobId');
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const fetchStatus = useSelector(selectFetchStatus);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (!jobInfo || !jobId) return;
        setSearchParams({
            jobId: jobId,
            jobTitle: jobInfo.title
        });
    }, [jobInfo]);

    const fetchData = async () => {
        if (!jobId) return;

        const user = (await dispatch(getUserInfoThunk())).payload;
        if (user) {
            navigate(`/workspace/exams/${jobId}`);
        } else {
            await dispatch(getJobInfoThunk(jobId));
        }
    };

    const submit = () => {
        if (!validateEmail(email)) {
            setError('Email address is invalid.');
            return;
        }

        dispatch(signInThunk({
            username: email,
            password,
            from: `/workspace/exams/${jobId}`,
        }));
    };

    return (
        <div className={styles.container}>
            <div className={styles.body}>
                <div className={styles.signin}>
                    <div className={styles.head}>
                        <TypographyLogo width={280} height={70} />
                        <span className={styles.head_title}>Sign in</span>
                    </div>
                    <span className={styles.description}>Please sign in to continue to your account.</span>
                    <Input
                        focused
                        type="email"
                        value={email}
                        error={error}
                        onChange={setEmail}
                        placeholder="example@mail.co"
                        wrapperClassName={styles.username}
                    />
                    <Input
                        value={password}
                        type="password"
                        placeholder="password"
                        onChange={setPassword}
                    />
                    <div className={styles.midd_row}>
                        <CheckBox
                            text="Remember Me"
                            checked={rememberMe}
                            setChecked={setRememberMe}
                        />
                        <span onClick={() => navigate('/forgetpassword')}>
                            Forgot your password?
                        </span>
                    </div>
                    <Button
                        text="Sign In"
                        onClick={submit}
                        loading={fetchStatus === 'Pending'}
                    />
                    <div className={styles.joinNow}>
                        <span>Don’t have an account? </span>
                        <span onClick={() => navigate('/signup', { state: { from: `/workspace/exams/${jobId}` } })}>Sign up</span>
                    </div>
                </div>
                <div className={styles.job_description}>
                    <div className={styles.job_description_content}>
                        {loading && <Loading className={styles.loading} />}
                        {!loading && jobInfo && <>
                            <div className={styles.company}>
                                <div className={styles.company_logo}>
                                    {jobInfo.companyLogo ? <img src={jobInfo.companyLogo} alt="" /> :
                                        <span>{jobInfo.companyName?.slice(0, 1)}</span>}
                                </div>
                                <span className={styles.company_name}>{jobInfo.companyName}</span>
                            </div>
                            <span className={styles.job_title}>{jobInfo.title}</span>
                            <div className={styles.job_detail}>
                                <span className={styles.job_detail_item}>{jobInfo?.jobType.title}</span>
                                <span className={styles.job_detail_item}>
                                    Base Salary Amount: {jobInfo.baseSalaryAmount || '---'} $ / {jobInfo.baseSalaryFrequency?.title}
                                </span>
                                <span className={styles.job_detail_item}>
                                    {jobInfo.city?.city} / {jobInfo.state?.state} / {jobInfo.country?.title}
                                </span>
                            </div>
                            <div className={styles.description}>
                                <span className={styles.description_title}>Job description</span>
                                <p>{jobInfo.description}</p>
                            </div>
                        </>}
                    </div>
                    <span className={styles.job_description_slogan}>Creating equal opportunities in recruitment</span>
                </div>
            </div>
        </div>
    )
};

export default JobDescription;
